import * as React from 'react'

import { Box, Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import CopyPeriodWizard from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard'

interface Props {
  disabled?: boolean
}
const CopyPeriodButton = ({ disabled }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
  const [isTooltipOpen, toggleTooltip] = useToggle(false)

  return (
    <>
      {isModalOpen && <CopyPeriodWizard onClose={() => setIsModalOpen(false)} />}
      <Box onMouseEnter={toggleTooltip(!disabled)} onMouseLeave={toggleTooltip(false)}>
        <Tooltip.Alt
          open={isTooltipOpen}
          attachment="top center"
          label={i18n.t('shift_management.actions.copy_schedule_period')}
        >
          <Button
            type="secondary"
            onClick={() => setIsModalOpen(true)}
            disabled={disabled}
            iconName="layers-front"
          />
        </Tooltip.Alt>
      </Box>
    </>
  )
}

export default CopyPeriodButton
